import React, { useEffect, useState } from 'react'
// import useLogout from '../../hooks/useLogout';
import { useOperatorContext } from '../login/OperatorContextProvider';
import UserFocus from './UserFocus';
import './UserBox.css';

const getFirstNameOrUsername = (anOperator) => anOperator?.firstName ? anOperator.firstName : anOperator?.username;

export default function UserBox() {
  const {operator} = useOperatorContext();  
  // const {logout} = useLogout();
  const [displayName, setDisplayName] = useState('');
  
  useEffect(()=>{
    if (operator?.username) {
      setDisplayName( getFirstNameOrUsername(operator) );
    }

  },[operator]);

  // const handleSignOut = () => {
  //   logout();
  // }

  // let box = <SignInLink/>;
  
  // if (operator?.username) {
  //   const uName = operator.firstName ? operator.firstName : operator.username;
  //   box = <div className='hiBox'>
  //           <UserFocus uName={uName}/>
  //           <div>
  //             <button className='headerButton' onClick={handleSignOut}>Sign Out</button>
  //           </div>
  //         </div>;
  // }

  return (
    <div className='userBox'>
      <UserFocus uName={displayName}/>
    </div>
  )
}
